/** @format */

const filters = {
	/**
	 * 附件容量数字 格式化
	 * @param num
	 * @param digits
	 */
	numberFormatter(num: number, digits = 2) {
		if (!num) {
			return '';
		}
		const si = [
			{ value: 1e18, symbol: 'E' },
			{ value: 1e15, symbol: 'P' },
			{ value: 1e12, symbol: 'T' },
			{ value: 1e9, symbol: 'G' },
			{ value: 1e6, symbol: 'M' },
			{ value: 1e3, symbol: 'k' },
		];
		for (let i = 0; i < si.length; i++) {
			if (num >= si[i].value) {
				return (num / si[i].value + 0.1).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol;
			}
		}
		return num.toString();
	},
};
export { filters };
